import React, { useState } from "react";

export default function UnifiedLeadForm({
  sessionId,
  intent, // "/medops_submit" | "/pharma_submit" | "/other_submit"
  fields = [
    { name: "fullName", label: "Full name", type: "text", required: true },
    { name: "phoneNumber", label: "Phone number", type: "tel", required: true },
    { name: "email", label: "Email", type: "email", required: true },
  ],
  onFormSubmit, // optional hook after success
  onFormSubmitIntent, // (message, payload) => Promise<void>
}) {
  const init = {};
  fields.forEach((f) => (init[f.name] = ""));
  const [data, setData] = useState(init);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const set = (name) => (e) => setData((d) => ({ ...d, [name]: e.target.value }));

  const validate = () => {
    // generic requireds
    for (const f of fields) {
      if (f.required && !(data[f.name] || "").trim()) {
        return `${f.label} is required`;
      }
    }
    // patterns
    if (!/^[6-9]\d{9}$/.test(data.phoneNumber || "")) return "Phone must be 10 digits (India)";
    if (!/^\S+@\S+\.\S+$/.test(data.email || "")) return "Valid email required";
    return null;
  };

  const submit = async (e) => {
    e.preventDefault();
    const v = validate();
    if (v) return setErr(v);
    setErr(null);
    setLoading(true);
    try {
      const payload = {};
      fields.forEach((f) => (payload[f.name] = (data[f.name] || "").trim()));
      await onFormSubmitIntent(intent, payload);
      onFormSubmit && onFormSubmit();
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} style={{ display: "grid", gap: 8 }}>
      {err && <div style={{ color: "#b00020", fontSize: 12 }}>{err}</div>}

      {fields.map((f) => (
        <input
          key={f.name}
          required={f.required}
          type={f.type || "text"}
          placeholder={f.label}
          value={data[f.name] ?? ""}
          onChange={set(f.name)}
          style={{
            width: "100%",
            border: "1px solid rgba(0,0,0,.1)",
            padding: "8px 10px",
            borderRadius: 10,
            fontSize: 13,
          }}
        />
      ))}

      <button
        type="submit"
        disabled={loading}
        style={{
          border: "none",
          background: "linear-gradient(135deg, #2563eb, #3b82f6)",
          color: "#fff",
          padding: "8px 12px",
          fontWeight: 800,
          borderRadius: 10,
        }}
      >
        {loading ? "Submitting…" : "Submit"}
      </button>
    </form>
  );
}